export type Context<T = undefined> = {
	startTime: number
	stackReference: Error

	data: T
}

/** Create a context-object for later calculating duration and setting the original stack */
export const createErrorContext = <T>(data: T, parentFunction?: Function): Context<T> => {
	const stackReference = new Error()

	// Attempt to remove unnecessary stack-frames from the error

	Error.captureStackTrace?.(stackReference, parentFunction ?? createErrorContext)

	return { startTime: Date.now(), stackReference, data }
}

export const getDuration = (startTime: number) => (Date.now() - startTime) / 1000

export const fixStack = <T extends Error>(stackReference: Error, error: T) => {
	stackReference.name = error.name
	stackReference.message = error.message

	Object.defineProperty(error, 'stack', { get: () => stackReference.stack })

	return error
}
